import React from "react";
import { INextActionWidget } from "../../../common/interfaces";
import {
	FormControl,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
	FormHelperText,
} from "../../../common/MaterialComponent";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

export interface NextActionProps {
	widgetList: INextActionWidget[];
	selectedWidget: string;
	onNextActionChange: (value: string) => void;
	highlightRequiredDetail?: boolean;
	isValidationRequired?: boolean;
}
export const NextActionSelection: React.FC<NextActionProps> = ({
	widgetList,
	selectedWidget,
	onNextActionChange,
	highlightRequiredDetail,
	isValidationRequired,
}) => {
	const strings = useGetComponentStringsContext().NextActionSelection;

	const handleNextActionSelection = (event: any) => {
		onNextActionChange(event.target.value as string);
	};

	return (
		<div data-testid="nextActionContainer">
			<FormControl fullWidth required={isValidationRequired ?? false}>
				<InputLabel>{strings.nextActionLabel}</InputLabel>
				<Select
					data-testid="nextAction"
					value={selectedWidget}
					onChange={handleNextActionSelection}
					error={
						!selectedWidget && isValidationRequired && highlightRequiredDetail
					}
				>
					{widgetList?.map((option: INextActionWidget) => (
						<MenuItem
							key={option.id}
							value={option.id}
							className={option.isCustomMenu ? "customMenuNextAction" : ""}
							data-testid="customMenu"
						>
							<ListItemText primary={option.title} />
						</MenuItem>
					))}
				</Select>
				{!selectedWidget && isValidationRequired && highlightRequiredDetail && (
					<FormHelperText
						data-testid="errorMessageDiv"
						error={
							!selectedWidget && isValidationRequired && highlightRequiredDetail
						}
					>
						{strings.nextActionErrorMessage}
					</FormHelperText>
				)}
			</FormControl>
		</div>
	);
};
